<template>
  <div class="row">
    <loading v-if="loadingRender"></loading>
    <div class="btn Pointer btn-outline-info d-none" @click="openModal" data-toggle="modal" data-target="#Modal-RegisterCheck">
      <i class="fas fa-list ml-2"></i>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="Modal-RegisterCheck" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="Modal-SettingLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h5 class="modal-title text-dark" id="Modal-SettingLabel">رهگیری ثبت نام</h5>
          </div>
          <div class="modal-body text-right">
            <div class="row px-3">
              <div class="col-12 col-md-12 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-12 text-right">
                      <span class="text-secondary">کدملی : </span>
                      <input type="number" maxlength="10" @keypress="$ValidNumber($event, 10)" class="form-control text-center" dir="ltr" v-model="CodeMeli" placeholder="کد ملی " />
                    </div>
                    <div v-if="NotCode" class="col-12 text-right">
                      <span class="text-secondary">کد رهگیری : </span>
                      <input type="number" maxlength="20" @keypress="$ValidNumber($event, 20)" class="form-control text-center" dir="ltr" v-model="CodeRahgiri" placeholder="کد رهگیری " />
                    </div>
                    <div class="col-12 mt-1 text-center">
                      <button @click="getData()" class="btn btn-submit w-100 mt-2">جستجو</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="$router.go(-1)" class="btn btn-secondary" data-dismiss="modal">انصراف</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-12"></div>
    <div class="col-md-8 col-12">
      <net-pa-card>
        <template v-slot:header>
          <h6 class="text-right"><i class="fas fa-cheque ml-2"></i> بررسی وضعیت درخواست عضویت</h6>
          <button @click="search()" class="btn btn-sm btn-warning NetPa-btn float-left m-1">جستجو</button>
          <button @click="GoToLogin()" class="btn btn-sm btn-info NetPa-btn float-left m-1">بازگشت</button>
        </template>
        <template slot="content">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a class="nav-item nav-link text-dark active" id="nav-aut-tab" data-toggle="tab" href="#nav-aut" role="tab" aria-controls="nav-aut" aria-selected="true" @click="currentIndex = 0"> احراز هویت </a>
              <a class="nav-item nav-link text-dark" id="nav-pay-tab" data-toggle="tab" href="#nav-pay" role="tab" aria-controls="nav-pay" aria-selected="false" @click="currentIndex = 1"> {{ $session.get('CustCode')==932?'خرید سهام':'پرداخت حق عضویت' }} </a>
              <a class="nav-item nav-link text-dark" id="nav-state-tab" data-toggle="tab" href="#nav-state" role="tab" aria-controls="nav-state" aria-selected="false" @click="currentIndex = 2"> وضعیت درخواست </a>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane show active py-5" id="nav-aut" role="tabpanel" aria-labelledby="nav-home-tab">
              <div v-if="GatData" class="col-12 mt-2 mb-4 text-center">
                <div class="row">
                  <div class="col-md-4 col-12 text-md-left text-center">
                    <i class="fas fa-user-shield text-success fa-5x"></i>
                  </div>
                  <div class="col-md-8 col-12 text-md-right text-center mt-2">
                    <h5 class="mx-2 text-success mb-2">احراز هویت با موفقیت انجام شده</h5>
                    <h6 class="mx-2 text-success mb-2">اطلاعات هویتی شما (توسط سامانه ثبت احوال) مورد تایید میباشد</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade py-2" id="nav-pay" role="tabpanel" aria-labelledby="nav-Account-tab">
              <div class="row">
                <div class="col-12">
                  <div class="col-12 alert alert-warning font-weight-bold">(صدور وجه از طریق بانک امکان پذیر می باشد)</div>
                </div>
                <div class="col-12">
                  <div class="btn-group-toggle w-50" data-toggle="buttons" tabindex="-1">
                    <label tabindex="-1" class="btn btn-dark Pointer col-md-6 col-12" :class="Ravesh == 1 ? 'active focus' : ''">
                      <input tabindex="-1" @click="Ravesh = 1" type="radio" name="options" id="rdiNaghdi" />
                      پرداخت آنلاین
                    </label>
                    <label v-if="this.$session.get('CustCode') == '932'" tabindex="-1" class="btn btn-dark Pointer col-md-6 col-12" :class="Ravesh == 2 ? 'active focus' : ''">
                      <input tabindex="-1" @click="Ravesh = 2" type="radio" name="options" id="rdiBanki" />
                      آپلود فیش بانکی
                    </label>
                  </div>
                  <div v-if="Ravesh == 1">
                    <div class="row" v-if="this.GatData.codeRahgiri == 'BnpCo'" id="div1">
                      <div class="col-md-4 col-12 mt-3">
                        <h6 class="">مبلـــــــغ واریزی :</h6>
                        <input class="form-control mt-2 text-center 3ragham mb-2" id="Mab" :disabled="FixVariz" v-model="Mablagh" dir="ltr" type="number" placeholder="مبلغ واریزی" style="font-size: 15px !important" />
                        <span class="text-danger h6 mt-2"> {{ $Comma3ragham(Mablagh) }} </span> ریال
                        <!-- <span class=" "> {{ ToPersian(Mablagh) }} ريال </span> -->
                      </div>

                      <div class="col-md-8 col-12 mt-2 mb-5">
                        <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
                          <template v-slot:ContentButtonPayment>
                            <button id="BtnPayment" class="btn w-50" :class="!loading || Number(Mablagh) < 10000 ? 'btn-secondary' : 'btn-success'" :disabled="!loading || Number(Mablagh) < 10000" @click.prevent="Payment">
                              واریز
                              {{ $Comma3ragham(Mablagh) }} ريال
                            </button>
                          </template>
                        </payment>
                      </div>
                    </div>
                    <div v-else>
                      <div class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                        <div class="alert text-center bg-success-custom w-100">
                          <i class="fas fa-check-circle text-success" style="font-size: 17px !important"></i>
                          <span class="text-dark" style="font-size: 17px !important">{{ TextVazeiat }}</span>
                        </div>
                        <span class="text-dark text-center" style="font-size: 17px !important">تاریخ : {{ GatData.tarixSanad }}</span>
                        <span class="text-dark text-center mt-3" style="font-size: 17px !important">کد رهگیری : {{ Rahgiri }}</span>
                        <span class="text-dark text-center mt-3" style="font-size: 17px !important"> مشخصات پرداخت کننده :{{ GatData.ozvName + ' ' + GatData.ozvFamily }} </span>
                        <span class="text-dark text-center mt-3" style="font-size: 17px !important"> مبلغ پرداختی : {{ $Comma3ragham(GatData.bestan) }} </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="Ravesh == 2">
                    <div class="row">
                      <div class="col-12 text-center mt-3">
                        <span class="" style="font-size: 17px"> لطفا فیش واریزی خود به مبلغ</span>
                        <span class="text-danger" style="font-size: 20px"> {{ $Comma3ragham(Mablagh) }} ریال </span>
                        <span class="" style="font-size: 17px"> را آپلود نمایید </span>
                      </div>
                      <div class="col-12 text-center mt-2 mb-5">
                        <input type="file" @change="changefile($event)" class="d-none" id="Uploader" accept=".gif,.jpg,.jpeg,.png,.pdf" />
                        <button class="btn btn-outline-primary mt-3 mb-3 px-5 py-2" @click.prevent="clickUploader"><i class="fa fa-attachment"></i> بار گذاری فیش واریزی</button>
                        <div class="mt-3" v-if="fileinfo.name">
                          <span> نام فایل : {{ fileinfo.name }}</span>
                        </div>
                        <div class="mt-2" v-if="fileinfo.size">
                          <span> حجم فایل : {{ (fileinfo.size / 1000000).toFixed(2) }} MB </span>
                        </div>
                        <div class="mt-2" v-if="fileinfo.size && fileinfo.name">
                          <button class="btn btn-success mt-3 mb-3 px-5 py-2" @click="UploadFishVariz">آپلود فیش</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade py-2" id="nav-state" role="tabpanel" aria-labelledby="nav-home-tab">
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070520" class="card mt-md-5 Netpa-Shadow p-2 border-secondary" id="cardNetpa">
                <div class="alert text-center bg-success-custom w-100">
                  <i class="fas fa-times-circle text-success" style="font-size: 17px !important"></i>
                  <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما با موفقیت تایید شده است </span>
                </div>
              </div>
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070521" class="mt-md-5 p-2" id="cardNetpa">
                <div class="alert text-center alert-info w-100">
                  <!-- <i class="fas fa-times-circle text-danger" style="font-size: 17px !important"></i> -->
                  <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما تایید نشده است </span>
                </div>
                <span class="text-dark text-center" style="font-size: 17px !important">علت رد درخواست : {{ GatData.desState }}</span>
              </div>
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070522" class="mt-md-2 p-2" id="cardNetpa">
                <div class="alert text-center alert-info w-100">
                  <!-- <i class="fas fa-times-circle text-warning" style="font-size: 17px !important"></i> -->
                  <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما نیاز به اصلاح دارد </span>
                </div>
                <span class="text-dark text-center" style="font-size: 17px !important">توضیحات اصلاح : {{ GatData.desState }}</span>
                <button class="btn btn-warning mr-1 mt-3 no-print" type="button" @click="GetRigister(GatData.id)"><span class="mr-2" style="font-size: 17px !important"> اصلاح اطلاعات </span></button>
              </div>
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070519" class="mt-md-2 p-2" id="cardNetpa">
                <div class="alert text-center alert-info w-100">
                  <!-- <i class="fas fa-times-circle text-info" style="font-size: 17px !important"></i> -->
                  <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما در حال بررسی میباشد </span>
                </div>
              </div>
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070518" class="mt-md-2 p-2" id="cardNetpa">
                <div class="alert text-center alert-info w-100">
                  <!-- <i class="fas fa-times-circle text-info" style="font-size: 17px !important"></i> -->
                  <span class="text-dark" style="font-size: 17px !important"> لطفا از مرحله دوم پرداخت حق عضویت را انجام دهید </span>
                </div>
              </div>
              <div v-if="this.GatData != null && this.GatData.wwwtblcomboidgrp331 == 181070525" class="mt-md-2 p-2" id="cardNetpa">
                <div class="alert text-center alert-info w-100">
                  <!-- <i class="fas fa-times-circle text-info" style="font-size: 17px !important"></i> -->
                  <span class="text-dark" style="font-size: 17px !important"> درخواست عضویت شما درحال بررسی میباشد (توسط فیش واریزی)</span>
                </div>
              </div>
            </div>
          </div>

          <button type="button" class="btn btn-info float-left" v-if="currentIndex != 2" @click="Go">مرحــــله بعدی <i class="fa fa-arrow-left mr-3"></i></button>
        </template>
      </net-pa-card>
    </div>
    <div class="col-md-2 col-12"></div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Payment from '../CmpNetPa/Payment.vue'
import Num2persian from 'num2persian'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  components: { NetPaCard, Payment, Num2persian, loading },
  data() {
    return {
      appsettings: null,
      fileinfo: {},
      NotCode: false,
      loadingRender: false,
      DesState: '',
      Tarix: '',
      Rahgiri: '',
      TextVazeiat: ' تراکنش با موفقیت انجام شد ',
      FixVariz: false,
      GatewayCode: null,
      Mablagh: 0,
      divToShow: 1,
      loading: false,
      DataAxios: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NewtblAza',
        Token: this.$session.get('TokenNetPa'),
      },
      CodeMeli: '',
      CodeRahgiri: null,
      GatData: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      WwwtblTaahodatId: 0,
      currentIndex: 0,
      Ravesh: 0,
      IsUpload: false,
    }
  },
  methods: {
    UploadFishVariz() {
      let DataAxiosUpload = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EftetahHesab/SaveAttachmentToDb',
        Token: '',
      }
      var formdata = new FormData()
      formdata.append('IdEftetah', this.CodeRahgiri)
      formdata.append('Image', this.fileinfo)
      formdata.append('wwwtblcomboidgrp328', 181070524)
      formdata.append('TableName', 'wwwNewtblAzaForEftetahHesab')
      DataAxiosUpload.ArryfildValue = formdata
      this.$PostFormData(DataAxiosUpload).then((data) => {
        this.IsUpload = true
        this.ChangeCombo331()
      })
    },
    clickUploader() {
      document.getElementById('Uploader').click()
    },
    changefile(e) {
      const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']

    const fileExtension = file.name.split('.').pop().toLowerCase()

    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      if (document.getElementById('Uploader').files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost('عملیات ناموفق', '  حجم فایل تصویر کارت ملی بیشتر از 5 مگابایت است ', 'error', 3000)
        return
      } else {
        // console.log(document.getElementById('Uploader1').files[0]);
        this.fileinfo = document.getElementById('Uploader').files[0]
        this.fileinfo1Isedit = true
      }
    },
    GetRigister(rowid) {
      this.$router.push({ name: 'Register', params: { RegisterCheck: rowid } })
    },
    GoToLogin() {
      this.$router.push('/')
    },
    ToPersian(number) {
      return Num2persian(number)
    },
    FixVarizGhest(val) {
      this.FixVariz = val
    },
    Get_GatewayCode(val) {
      if (this.$session.get('CustCode') == 932) {
        this.GatewayCode = 932
      } else {
        this.GatewayCode = val
      }
    },
    Payment() {
      this.SendPayment()
    },
    SendPayment() {
      if (this.Mablagh < JSON.parse(this.$GetMablaghEftetahHesab())) {
        this.$mySweetDefault('هشدار', 'مبلغ وارد شده از حداقل مبلغ برای حق عضویت کمتر می باشد', 'warning', 3000)
        return
      } else {
        var WwwtblAzaId=0
        var BnpCashDBtblTaahodatId = 0
        var BnpCashDBtblAzaId = 0 

        var formdata = new FormData()
        formdata.append('id', this.CodeRahgiri)
        formdata.append('noeId', Number(JSON.parse(this.$GetNoeIdPishFarz())))
        var DataAxios_AzaForEftetahHesab = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'AzaForEftetahHesab',
          Token: '',
        }

        this.$PostFormData(DataAxios_AzaForEftetahHesab)
          .then((data) => {
            if (data.status == 'OK') {
              this.WwwtblTaahodatId = data.wwwtblTaahodatId
              WwwtblAzaId = data.wwwtblAzaId ==undefined ?0 :data.wwwtblAzaId ;
              BnpCashDBtblTaahodatId = data.bnpCashDBtblTaahodatId==undefined ?0 :data.bnpCashDBtblTaahodatId;
              BnpCashDBtblAzaId = data.bnpCashDBtblAzaId==undefined ?0 :data.bnpCashDBtblAzaId;
            } else if (data.status == 'true') {
              this.WwwtblTaahodatId = data.wwwtblTaahodatId
            }
          })
          .finally(() => {
            this.Mablagh = this.Mablagh
            const WwwtblVarizGorohiRiz = []
            WwwtblVarizGorohiRiz.push({
              WwwtblTaahodatId: this.WwwtblTaahodatId,
              Mablagh: Number(this.Mablagh),
              SharhRiz: 'واریز حق عضویت جهت ثبت نام اولیه' + ' _پرداخت کننده_ ' + this.GatData.ozvName + ' ' + this.GatData.ozvFamily + this.GatData.codeMeli.trim(),
              WwwtblAzaId:this.WwwtblTaahodatId>0 ?  WwwtblAzaId :Number(this.CodeRahgiri * -1),
              BnpCashDBtblTaahodatId: this.WwwtblTaahodatId>0 ? BnpCashDBtblTaahodatId : this.WwwtblTaahodatId,
              BnpCashDBtblAzaId: this.WwwtblTaahodatId>0 ?  BnpCashDBtblAzaId : Number(this.CodeRahgiri * -1),
              MablaghJarime: 0,
              TarixGhest: this.$store.state.JalaliDate,
              IsTaahodatRiz: false,
            })

            this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh)
            this.DataAxios_Variz.ArryfildValue.CodeRahgiri = this.WwwtblTaahodatId>0 ?  Number(this.CodeRahgiri) : -1
            this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
            this.DataAxios_Variz.ArryfildValue.Sharh = 'واریز حق عضویت جهت ثبت نام اولیه' + ' _پرداخت کننده_ ' + this.GatData.ozvName + ' ' + this.GatData.ozvFamily + this.GatData.codeMeli.trim()
            this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
            this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('CustCode'))
            this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
            this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.WwwtblTaahodatId>0 ?  WwwtblAzaId: Number(this.CodeRahgiri * -1)
            this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
            this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
            this.$PostData(this.DataAxios_Variz).then((result) => {
              if (result.status === 'Success') {
                this.$Payment(
                  this.GatewayCode + '',
                  this.Mablagh + '',
                  this.GatData.ozvName + ' ' + this.GatData.ozvFamily,
                  'RegisterCheck',
                  this.GatData.mobile,
                  WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
                  1 + '',
                  '-1',
                  'واریز حق عضویت جهت ثبت نام اولیه',
                  this.WwwtblTaahodatId>0 ?  WwwtblAzaId  + '' : Number(this.CodeRahgiri * -1) + '',
                  this.$session.get('CustCode'),
                  this.GatData.wwwtblShobeId + '',
                  result.idRepoMaster,
                  this.GatData.codeMeli.trim()
                )
              } else {
                this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 4000)
                this.DeleteAllItemsCart()
              }
            })
          })
      }
    },
    ChangeCombo331() {
      var formdata = new FormData()
      formdata.append('id', this.CodeRahgiri)
      var DataAxios_AzaForEftetahHesab = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'AzaForEftetahHesab/PayByUploadFish',
        Token: '',
      }

      this.$PostFormData(DataAxios_AzaForEftetahHesab).then((data) => {
        if (data == true) {
          this.getData()
          this.selectCurent(document.getElementById('head' + 3), 3)
        }
      })
    },
    search() {
      this.openModal()
    },
    GoToLogin() {
      this.$router.push('/')
    },
    openModal() {
      $('#Modal-RegisterCheck').modal('show')
    },
    closeModal() {
      $('#Modal-RegisterCheck').modal('hide')
    },
    getData() {
      this.closeModal()
      if (this.CodeMeli != '') {
        this.loadingRender = true
        this.loading = false
        const formData = new FormData()
        formData.append('CodeMeli', this.CodeMeli)
        formData.append('CodeRahgiri', this.CodeRahgiri)
        this.DataAxios.ArryfildValue = formData
        this.$PostFormData(this.DataAxios).then((data) => {
          if (data != null) {
            this.Ravesh = 1
            this.loading = true
            this.GatData = data
            this.Mablagh = this.appsettings.MablaghEftetahHesab
            this.Rahgiri = data.codeRahgiri
            this.loadingRender = false
           
            //#region برای صندوق مادر  مبالغ عضویت متفاوت میشود 
            if (this.$session.get('CustCode')=='953') {
              // نوع مشتری ==> کسبه مادر
              if (data.wwwtblTafsiliTypeId==11991) {
                this.Mablagh=5000000;
              }
              else{
                this.Mablagh=1000000;
              }
            }
            //#endregion
            
            this.closeModal()
          } else {
            this.loading = false
            this.loadingRender = false
            this.$mySweetDefault('هشدار', 'کد ملی وارد شده معتبر نیست ', 'warning', 3000)
          }
        })
      } else {
        this.loading = false
        this.loadingRender = false
        this.$mySweetDefault('هشدار', 'کد ملی وارد نشده است ', 'warning', 3000)
      }
    },
    nextPage(number) {
      this.selectCurent(document.getElementById('head' + number), number)
    },
    selectCurent(data, number) {
      var headers = document.getElementsByClassName('hoverHeader')
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index]
        element.classList.remove('current')
      }
      if (data.target) {
        data.target.parentNode.classList.add('current')
      } else {
        data.parentNode.classList.add('current')
      }
      this.divToShow = number
    },
    Go() {
      if (this.currentIndex == 1 && this.IsUpload == false && this.Ravesh == 2) {
        this.$mySweetDefault('عدم بارگذاری فیش', 'لطفا فیش واریزی خودرا بارگذاری و آپلود نمایید', 'warning', 3000)
        return
      }
      var alltabs = document.getElementsByClassName('nav-item')
      var ct = alltabs.length
      var alltabsContent = document.getElementsByClassName('tab-pane')
      var ctc = alltabsContent.length

      alltabs[this.currentIndex].classList.remove('active')
      alltabsContent[this.currentIndex].classList.remove('active')
      alltabsContent[this.currentIndex].classList.remove('show')
      alltabsContent[this.currentIndex].classList.add('fade')

      if (this.currentIndex < ct - 1) {
        this.currentIndex++
      } else {
        // this.currentIndex = 0
      }

      alltabs[this.currentIndex].classList.add('active')
      alltabsContent[this.currentIndex].classList.remove('fade')
      alltabsContent[this.currentIndex].classList.add('active')
      alltabsContent[this.currentIndex].classList.add('show')
    },
    getCustomerDate() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: '/appSettings.json?nocache=123',
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          'Content-Type': 'application/json',
        },
      }
      axios(config).then((result) => {
        if (this.$store.state.VersionSoftware != result.data.VersionSoftware) {
          window.location = window.location.href + '?eraseCache=true'
        } else {
          this.appsettings = result.data
          this.gettblCustomer(this.appsettings.NetPaApi)
        }
      })
    },
    gettblCustomer(NetPaApi) {
      this.loadingRender=true
      var settings = {
        method: 'Post',
        url: NetPaApi + 'Setting',
        headers: {},
        data: null,
      }
      var axios = require('axios')
      axios(settings)
        .then((result) => {
          this.CountLogin = result.data.countAuth

          this.$PostData({
            ArryfildValue: {},
            Action: 'GetTblCustomer',
            method: 'GET',
            Token: '',
          })
            .then((data) => {
              let CustomerName = data.name
              if(data.custCode==561){
                this.$store.state.NameSandogh='صندوق قرض الحسنه'
                this.$session.set('NameSandogh', 'صندوق قرض الحسنه')
                CustomerName='صندوق قرض الحسنه';
              }
              else{
                this.$store.state.NameSandogh = data.name
                this.$session.set('NameSandogh', data.name)
                let word = 'تعاونی'
                if (CustomerName.indexOf(word) !== -1) {
                  this.$session.set('IsTaavoniEtebar', true)
                } else {
                  this.$session.set('IsTaavoniEtebar', false)
                }
              }
              this.$session.set('CustCode', data.custCode)
              document.title = ' خدمات الکترونیکی ' + data.name
              this.loadingRender = false
              this.loadingText = ' ورود به سامانه'
            })
            .catch((e) => {
               this.gettblCustomer()
            })
            .finally(() => {
              this.loadingRender = false
            })
        })
        .catch(() => {
          this.gettblCustomer()
        })
        .finally(() => {
          this.loadingRender = false
        })
    }
  },
  mounted() {
    this.getCustomerDate()
    if (this.$route.params.Status) {
      this.CodeRahgiri = this.$route.params.Status
      if (this.CodeRahgiri == 0) {
        this.NotCode = true
        this.CodeRahgiri = null
      }
      this.openModal()
    }
    // console.log(this.$route.params.Status);
  },
}
</script>
<style scoped>
.hoverHeader:hover {
  font-weight: bold;
  color: darkorchid;
  background: rgb(224, 221, 226);
  cursor: pointer;
  transition: all 0.5s ease-in;
}
.hoverHeader.current {
  font-weight: bold;
  color: #435ebe;
  background: #dee3f5;
  cursor: pointer;
  transition: all 0.5s ease-in;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>